export default __webpack_public_path__ + "static/media/left-arrow.8f4fa0b3.svg";